export const Paises = [
  {
    codigo: "9903",
    descricao: "PROVISAO DE NAVIOS E AERONAVES",
    siscomex: null,
  },
  {
    codigo: "9946",
    descricao: "A DESIGNAR",
    siscomex: null,
  },
  {
    codigo: "9950",
    descricao: "BANCOS CENTRAIS",
    siscomex: null,
  },
  {
    codigo: "9970",
    descricao: "ORGANIZACOES INTERNACIONAIS",
    siscomex: null,
  },
  {
    codigo: "4499",
    descricao: "MACEDONIA, ANT.REP.IUGOSLAVA",
    siscomex: null,
  },
  {
    codigo: "4525",
    descricao: "MADEIRA, ILHA DA",
    siscomex: null,
  },
  {
    codigo: "4901",
    descricao: "MIDWAY, ILHAS",
    siscomex: null,
  },
  {
    codigo: "6781",
    descricao: "SAINT KITTS E NEVIS",
    siscomex: null,
  },
  {
    codigo: "8737",
    descricao: "WAKE, ILHA",
    siscomex: null,
  },
  {
    codigo: "8958",
    descricao: "ZONA DO CANAL DO PANAMA",
    siscomex: null,
  },
  {
    codigo: "477",
    descricao: "ANTILHAS HOLANDESAS",
    siscomex: null,
  },
  {
    codigo: "175",
    descricao: "ALBANIA, REPUBLICA DA",
    siscomex: "17",
  },
  {
    codigo: "230",
    descricao: "ALEMANHA",
    siscomex: "23",
  },
  {
    codigo: "370",
    descricao: "ANDORRA",
    siscomex: "37",
  },
  {
    codigo: "418",
    descricao: "ANGUILLA",
    siscomex: "41",
  },
  {
    codigo: "434",
    descricao: "ANTIGUA E BARBUDA",
    siscomex: "43",
  },
  {
    codigo: "531",
    descricao: "ARABIA SAUDITA",
    siscomex: "53",
  },
  {
    codigo: "590",
    descricao: "ARGELIA",
    siscomex: "59",
  },
  {
    codigo: "647",
    descricao: "ARMENIA, REPUBLICA DA",
    siscomex: "64",
  },
  {
    codigo: "655",
    descricao: "ARUBA",
    siscomex: "65",
  },
  {
    codigo: "698",
    descricao: "AUSTRALIA",
    siscomex: "69",
  },
  {
    codigo: "728",
    descricao: "AUSTRIA",
    siscomex: "72",
  },
  {
    codigo: "779",
    descricao: "BAHAMAS, ILHAS",
    siscomex: "77",
  },
  {
    codigo: "817",
    descricao: "BANGLADESH",
    siscomex: "81",
  },
  {
    codigo: "833",
    descricao: "BARBADOS",
    siscomex: "83",
  },
  {
    codigo: "809",
    descricao: "BAHREIN, ILHAS",
    siscomex: "80",
  },
  {
    codigo: "850",
    descricao: "BELARUS, REPUBLICA DA",
    siscomex: "85",
  },
  {
    codigo: "876",
    descricao: "BELGICA",
    siscomex: "87",
  },
  {
    codigo: "884",
    descricao: "BELIZE",
    siscomex: "88",
  },
  {
    codigo: "906",
    descricao: "BERMUDAS",
    siscomex: "90",
  },
  {
    codigo: "981",
    descricao: "BOSNIA-HERZEGOVINA (REPUBLICA DA)",
    siscomex: "98",
  },
  {
    codigo: "1015",
    descricao: "BOTSUANA",
    siscomex: "101",
  },
  {
    codigo: "1058",
    descricao: "BRASIL",
    siscomex: "105",
  },
  {
    codigo: "1082",
    descricao: "BRUNEI",
    siscomex: "108",
  },
  {
    codigo: "310",
    descricao: "BURKINA FASO",
    siscomex: "31",
  },
  {
    codigo: "1155",
    descricao: "BURUNDI",
    siscomex: "115",
  },
  {
    codigo: "1198",
    descricao: "BUTAO",
    siscomex: "119",
  },
  {
    codigo: "1279",
    descricao: "CABO VERDE, REPUBLICA DE",
    siscomex: "127",
  },
  {
    codigo: "1457",
    descricao: "CAMAROES",
    siscomex: "145",
  },
  {
    codigo: "1414",
    descricao: "CAMBOJA",
    siscomex: "141",
  },
  {
    codigo: "1490",
    descricao: "CANADA",
    siscomex: "149",
  },
  {
    codigo: "7889",
    descricao: "CHADE",
    siscomex: "788",
  },
  {
    codigo: "5118",
    descricao: "CHRISTMAS,ILHA (NAVIDAD)",
    siscomex: "511",
  },
  {
    codigo: "7412",
    descricao: "CINGAPURA",
    siscomex: "741",
  },
  {
    codigo: "7838",
    descricao: "DJIBUTI",
    siscomex: "783",
  },
  {
    codigo: "6874",
    descricao: "EL SALVADOR",
    siscomex: "687",
  },
  {
    codigo: "8702",
    descricao: "FIJI",
    siscomex: "870",
  },
  {
    codigo: "1504",
    descricao: "GUERNSEY, ILHA DO CANAL (INCLUI ALDERNEY E SARK)",
    siscomex: "321",
  },
  {
    codigo: "5738",
    descricao: "prouser.paises BAIXOS (HOLANDA)",
    siscomex: "573",
  },
  {
    codigo: "4456",
    descricao: "LUXEMBURGO",
    siscomex: "445",
  },
  {
    codigo: "4472",
    descricao: "MACAU",
    siscomex: "447",
  },
  {
    codigo: "4502",
    descricao: "MADAGASCAR",
    siscomex: "450",
  },
  {
    codigo: "4588",
    descricao: "MALAVI",
    siscomex: "458",
  },
  {
    codigo: "4618",
    descricao: "MALDIVAS",
    siscomex: "461",
  },
  {
    codigo: "4642",
    descricao: "MALI",
    siscomex: "464",
  },
  {
    codigo: "4677",
    descricao: "MALTA",
    siscomex: "467",
  },
  {
    codigo: "4740",
    descricao: "MARROCOS",
    siscomex: "474",
  },
  {
    codigo: "4766",
    descricao: "MARSHALL,ILHAS",
    siscomex: "476",
  },
  {
    codigo: "4774",
    descricao: "MARTINICA",
    siscomex: "477",
  },
  {
    codigo: "4855",
    descricao: "MAURICIO",
    siscomex: "485",
  },
  {
    codigo: "4880",
    descricao: "MAURITANIA",
    siscomex: "488",
  },
  {
    codigo: "4936",
    descricao: "MEXICO",
    siscomex: "493",
  },
  {
    codigo: "4995",
    descricao: "MICRONESIA",
    siscomex: "499",
  },
  {
    codigo: "5053",
    descricao: "MOCAMBIQUE",
    siscomex: "505",
  },
  {
    codigo: "4944",
    descricao: "MOLDAVIA, REPUBLICA DA",
    siscomex: "494",
  },
  {
    codigo: "4952",
    descricao: "MONACO",
    siscomex: "495",
  },
  {
    codigo: "4979",
    descricao: "MONGOLIA",
    siscomex: "497",
  },
  {
    codigo: "4985",
    descricao: "MONTENEGRO",
    siscomex: "498",
  },
  {
    codigo: "5070",
    descricao: "NAMIBIA",
    siscomex: "507",
  },
  {
    codigo: "5088",
    descricao: "NAURU",
    siscomex: "508",
  },
  {
    codigo: "5177",
    descricao: "NEPAL",
    siscomex: "517",
  },
  {
    codigo: "5215",
    descricao: "NICARAGUA",
    siscomex: "521",
  },
  {
    codigo: "5258",
    descricao: "NIGER",
    siscomex: "525",
  },
  {
    codigo: "5282",
    descricao: "NIGERIA",
    siscomex: "528",
  },
  {
    codigo: "5355",
    descricao: "NORFOLK,ILHA",
    siscomex: "535",
  },
  {
    codigo: "5380",
    descricao: "NORUEGA",
    siscomex: "538",
  },
  {
    codigo: "5428",
    descricao: "NOVA CALEDONIA",
    siscomex: "542",
  },
  {
    codigo: "5487",
    descricao: "NOVA ZELANDIA",
    siscomex: "548",
  },
  {
    codigo: "5568",
    descricao: "OMA",
    siscomex: "556",
  },
  {
    codigo: "5754",
    descricao: "PALAU",
    siscomex: "575",
  },
  {
    codigo: "5800",
    descricao: "PANAMA",
    siscomex: "580",
  },
  {
    codigo: "5452",
    descricao: "PAPUA NOVA GUINE",
    siscomex: "545",
  },
  {
    codigo: "5762",
    descricao: "PAQUISTAO",
    siscomex: "576",
  },
  {
    codigo: "5860",
    descricao: "PARAGUAI",
    siscomex: "586",
  },
  {
    codigo: "5894",
    descricao: "PERU",
    siscomex: "589",
  },
  {
    codigo: "5932",
    descricao: "PITCAIRN,ILHA",
    siscomex: "593",
  },
  {
    codigo: "5991",
    descricao: "POLINESIA FRANCESA",
    siscomex: "599",
  },
  {
    codigo: "6033",
    descricao: "POLONIA, REPUBLICA DA",
    siscomex: "603",
  },
  {
    codigo: "6114",
    descricao: "PORTO RICO",
    siscomex: "611",
  },
  {
    codigo: "6238",
    descricao: "QUENIA",
    siscomex: "623",
  },
  {
    codigo: "6254",
    descricao: "QUIRGUIZ, REPUBLICA",
    siscomex: "625",
  },
  {
    codigo: "6289",
    descricao: "REINO UNIDO",
    siscomex: "628",
  },
  {
    codigo: "6408",
    descricao: "REPUBLICA CENTRO-AFRICANA",
    siscomex: "640",
  },
  {
    codigo: "6475",
    descricao: "REPUBLICA DOMINICANA",
    siscomex: "647",
  },
  {
    codigo: "7919",
    descricao: "TCHECA, REPUBLICA",
    siscomex: "791",
  },
  {
    codigo: "6602",
    descricao: "REUNIAO, ILHA",
    siscomex: "660",
  },
  {
    codigo: "6700",
    descricao: "ROMENIA",
    siscomex: "670",
  },
  {
    codigo: "6750",
    descricao: "RUANDA",
    siscomex: "675",
  },
  {
    codigo: "6769",
    descricao: "RUSSIA, FEDERACAO DA",
    siscomex: "676",
  },
  {
    codigo: "6858",
    descricao: "SAARA OCIDENTAL",
    siscomex: "685",
  },
  {
    codigo: "6777",
    descricao: "SALOMAO, ILHAS",
    siscomex: "677",
  },
  {
    codigo: "6904",
    descricao: "SAMOA",
    siscomex: "690",
  },
  {
    codigo: "6912",
    descricao: "SAMOA AMERICANA",
    siscomex: "691",
  },
  {
    codigo: "6971",
    descricao: "SAN MARINO",
    siscomex: "697",
  },
  {
    codigo: "7153",
    descricao: "SANTA LUCIA",
    siscomex: "715",
  },
  {
    codigo: "6955",
    descricao: "SAO CRISTOVAO E NEVES,ILHAS",
    siscomex: "695",
  },
  {
    codigo: "7005",
    descricao: "SAO PEDRO E MIQUELON",
    siscomex: "700",
  },
  {
    codigo: "7200",
    descricao: "SAO TOME E PRINCIPE, ILHAS",
    siscomex: "720",
  },
  {
    codigo: "7315",
    descricao: "SEYCHELLES",
    siscomex: "731",
  },
  {
    codigo: "7285",
    descricao: "SENEGAL",
    siscomex: "728",
  },
  {
    codigo: "7358",
    descricao: "SERRA LEOA",
    siscomex: "735",
  },
  {
    codigo: "7370",
    descricao: "SERVIA",
    siscomex: "737",
  },
  {
    codigo: "7447",
    descricao: "SIRIA, REPUBLICA ARABE DA",
    siscomex: "744",
  },
  {
    codigo: "7480",
    descricao: "SOMALIA",
    siscomex: "748",
  },
  {
    codigo: "7501",
    descricao: "SRI LANKA",
    siscomex: "750",
  },
  {
    codigo: "7595",
    descricao: "SUDAO",
    siscomex: "759",
  },
  {
    codigo: "7676",
    descricao: "SUICA",
    siscomex: "767",
  },
  {
    codigo: "7706",
    descricao: "SURINAME",
    siscomex: "770",
  },
  {
    codigo: "7765",
    descricao: "TAILANDIA",
    siscomex: "776",
  },
  {
    codigo: "7803",
    descricao: "TANZANIA, REP.UNIDA DA",
    siscomex: "780",
  },
  {
    codigo: "7820",
    descricao: "TERRITORIO BRIT.OC.INDICO",
    siscomex: "782",
  },
  {
    codigo: "7951",
    descricao: "TIMOR LESTE",
    siscomex: "795",
  },
  {
    codigo: "8001",
    descricao: "TOGO",
    siscomex: "800",
  },
  {
    codigo: "8109",
    descricao: "TONGA",
    siscomex: "810",
  },
  {
    codigo: "8052",
    descricao: "TOQUELAU,ILHAS",
    siscomex: "805",
  },
  {
    codigo: "8150",
    descricao: "TRINIDAD E TOBAGO",
    siscomex: "815",
  },
  {
    codigo: "8206",
    descricao: "TUNISIA",
    siscomex: "820",
  },
  {
    codigo: "8249",
    descricao: "TURCOMENISTAO, REPUBLICA DO",
    siscomex: "824",
  },
  {
    codigo: "8273",
    descricao: "TURQUIA",
    siscomex: "827",
  },
  {
    codigo: "8281",
    descricao: "TUVALU",
    siscomex: "828",
  },
  {
    codigo: "8311",
    descricao: "UCRANIA",
    siscomex: "831",
  },
  {
    codigo: "8338",
    descricao: "UGANDA",
    siscomex: "833",
  },
  {
    codigo: "8451",
    descricao: "URUGUAI",
    siscomex: "845",
  },
  {
    codigo: "5517",
    descricao: "VANUATU",
    siscomex: "551",
  },
  {
    codigo: "8486",
    descricao: "VATICANO, EST.DA CIDADE DO",
    siscomex: "848",
  },
  {
    codigo: "8508",
    descricao: "VENEZUELA",
    siscomex: "850",
  },
  {
    codigo: "8583",
    descricao: "VIETNA",
    siscomex: "858",
  },
  {
    codigo: "8630",
    descricao: "VIRGENS,ILHAS (BRITANICAS)",
    siscomex: "863",
  },
  {
    codigo: "8664",
    descricao: "VIRGENS,ILHAS (E.U.A.)",
    siscomex: "866",
  },
  {
    codigo: "1511",
    descricao: "CANARIAS, ILHAS",
    siscomex: null,
  },
  {
    codigo: "7560",
    descricao: "AFRICA DO SUL",
    siscomex: "756",
  },
  {
    codigo: "400",
    descricao: "ANGOLA",
    siscomex: "40",
  },
  {
    codigo: "639",
    descricao: "ARGENTINA",
    siscomex: "63",
  },
  {
    codigo: "736",
    descricao: "AZERBAIJAO, REPUBLICA DO",
    siscomex: "73",
  },
  {
    codigo: "2291",
    descricao: "BENIN",
    siscomex: "229",
  },
  {
    codigo: "973",
    descricao: "BOLIVIA",
    siscomex: "97",
  },
  {
    codigo: "1112",
    descricao: "BULGARIA, REPUBLICA DA",
    siscomex: "111",
  },
  {
    codigo: "1546",
    descricao: "CATAR",
    siscomex: "154",
  },
  {
    codigo: "1376",
    descricao: "CAYMAN, ILHAS",
    siscomex: "137",
  },
  {
    codigo: "1538",
    descricao: "CAZAQUISTAO, REPUBLICA DO",
    siscomex: "153",
  },
  {
    codigo: "1589",
    descricao: "CHILE",
    siscomex: "158",
  },
  {
    codigo: "1600",
    descricao: "CHINA, REPUBLICA POPULAR",
    siscomex: "160",
  },
  {
    codigo: "1635",
    descricao: "CHIPRE",
    siscomex: "163",
  },
  {
    codigo: "1651",
    descricao: "COCOS(KEELING),ILHAS",
    siscomex: "165",
  },
  {
    codigo: "1694",
    descricao: "COLOMBIA",
    siscomex: "169",
  },
  {
    codigo: "1732",
    descricao: "COMORES, ILHAS",
    siscomex: "173",
  },
  {
    codigo: "1775",
    descricao: "CONGO",
    siscomex: "177",
  },
  {
    codigo: "1830",
    descricao: "COOK, ILHAS",
    siscomex: "183",
  },
  {
    codigo: "1872",
    descricao: "COREIA, REP.POP.DEMOCRATICA",
    siscomex: "187",
  },
  {
    codigo: "1902",
    descricao: "COREIA, REPUBLICA DA",
    siscomex: "190",
  },
  {
    codigo: "1937",
    descricao: "COSTA DO MARFIM",
    siscomex: "193",
  },
  {
    codigo: "1961",
    descricao: "COSTA RICA",
    siscomex: "196",
  },
  {
    codigo: "1953",
    descricao: "CROACIA (REPUBLICA DA)",
    siscomex: "195",
  },
  {
    codigo: "1996",
    descricao: "CUBA",
    siscomex: "199",
  },
  {
    codigo: "2321",
    descricao: "DINAMARCA",
    siscomex: "232",
  },
  {
    codigo: "2356",
    descricao: "DOMINICA,ILHA",
    siscomex: "235",
  },
  {
    codigo: "2402",
    descricao: "EGITO",
    siscomex: "240",
  },
  {
    codigo: "2445",
    descricao: "EMIRADOS ARABES UNIDOS",
    siscomex: "244",
  },
  {
    codigo: "2399",
    descricao: "EQUADOR",
    siscomex: "239",
  },
  {
    codigo: "2437",
    descricao: "ERITREIA",
    siscomex: "243",
  },
  {
    codigo: "2470",
    descricao: "ESLOVACA, REPUBLICA",
    siscomex: "247",
  },
  {
    codigo: "2461",
    descricao: "ESLOVENIA, REPUBLICA DA",
    siscomex: "246",
  },
  {
    codigo: "2453",
    descricao: "ESPANHA",
    siscomex: "245",
  },
  {
    codigo: "2496",
    descricao: "ESTADOS UNIDOS",
    siscomex: "249",
  },
  {
    codigo: "2518",
    descricao: "ESTONIA, REPUBLICA DA",
    siscomex: "251",
  },
  {
    codigo: "7544",
    descricao: "SUAZILANDIA",
    siscomex: "754",
  },
  {
    codigo: "2534",
    descricao: "ETIOPIA",
    siscomex: "253",
  },
  {
    codigo: "2550",
    descricao: "FALKLAND (ILHAS MALVINAS)",
    siscomex: "255",
  },
  {
    codigo: "2593",
    descricao: "FEROE, ILHAS",
    siscomex: "259",
  },
  {
    codigo: "2674",
    descricao: "FILIPINAS",
    siscomex: "267",
  },
  {
    codigo: "2712",
    descricao: "FINLANDIA",
    siscomex: "271",
  },
  {
    codigo: "2755",
    descricao: "FRANCA",
    siscomex: "275",
  },
  {
    codigo: "2810",
    descricao: "GABAO",
    siscomex: "281",
  },
  {
    codigo: "2852",
    descricao: "GAMBIA",
    siscomex: "285",
  },
  {
    codigo: "2895",
    descricao: "GANA",
    siscomex: "289",
  },
  {
    codigo: "2917",
    descricao: "GEORGIA, REPUBLICA DA",
    siscomex: "291",
  },
  {
    codigo: "2933",
    descricao: "GIBRALTAR",
    siscomex: "293",
  },
  {
    codigo: "2976",
    descricao: "GRANADA",
    siscomex: "297",
  },
  {
    codigo: "3018",
    descricao: "GRECIA",
    siscomex: "301",
  },
  {
    codigo: "3050",
    descricao: "GROENLANDIA",
    siscomex: "305",
  },
  {
    codigo: "3093",
    descricao: "GUADALUPE",
    siscomex: "309",
  },
  {
    codigo: "3131",
    descricao: "GUAM",
    siscomex: "313",
  },
  {
    codigo: "3174",
    descricao: "GUATEMALA",
    siscomex: "317",
  },
  {
    codigo: "3379",
    descricao: "GUIANA",
    siscomex: "337",
  },
  {
    codigo: "3255",
    descricao: "GUIANA FRANCESA",
    siscomex: "325",
  },
  {
    codigo: "3298",
    descricao: "GUINE",
    siscomex: "329",
  },
  {
    codigo: "3344",
    descricao: "GUINE-BISSAU",
    siscomex: "334",
  },
  {
    codigo: "3310",
    descricao: "GUINE-EQUATORIAL",
    siscomex: "331",
  },
  {
    codigo: "3417",
    descricao: "HAITI",
    siscomex: "341",
  },
  {
    codigo: "3450",
    descricao: "HONDURAS",
    siscomex: "345",
  },
  {
    codigo: "3514",
    descricao: "HONG KONG",
    siscomex: "351",
  },
  {
    codigo: "3557",
    descricao: "HUNGRIA, REPUBLICA DA",
    siscomex: "355",
  },
  {
    codigo: "3573",
    descricao: "IEMEN",
    siscomex: "357",
  },
  {
    codigo: "3611",
    descricao: "INDIA",
    siscomex: "361",
  },
  {
    codigo: "3654",
    descricao: "INDONESIA",
    siscomex: "365",
  },
  {
    codigo: "3727",
    descricao: "IRA, REPUBLICA ISLAMICA DO",
    siscomex: "372",
  },
  {
    codigo: "3697",
    descricao: "IRAQUE",
    siscomex: "369",
  },
  {
    codigo: "3751",
    descricao: "IRLANDA",
    siscomex: "375",
  },
  {
    codigo: "3794",
    descricao: "ISLANDIA",
    siscomex: "379",
  },
  {
    codigo: "3832",
    descricao: "ISRAEL",
    siscomex: "383",
  },
  {
    codigo: "3867",
    descricao: "ITALIA",
    siscomex: "386",
  },
  {
    codigo: "3913",
    descricao: "JAMAICA",
    siscomex: "391",
  },
  {
    codigo: "3999",
    descricao: "JAPAO",
    siscomex: "399",
  },
  {
    codigo: "1508",
    descricao: "JERSEY, ILHA DO CANAL",
    siscomex: "393",
  },
  {
    codigo: "3964",
    descricao: "JOHNSTON, ILHAS",
    siscomex: "396",
  },
  {
    codigo: "4030",
    descricao: "JORDANIA",
    siscomex: "403",
  },
  {
    codigo: "4111",
    descricao: "KIRIBATI",
    siscomex: "411",
  },
  {
    codigo: "1988",
    descricao: "COVEITE",
    siscomex: "198",
  },
  {
    codigo: "4200",
    descricao: "LAOS, REP.POP.DEMOCR.DO",
    siscomex: "420",
  },
  {
    codigo: "4260",
    descricao: "LESOTO",
    siscomex: "426",
  },
  {
    codigo: "4278",
    descricao: "LETONIA, REPUBLICA DA",
    siscomex: "427",
  },
  {
    codigo: "4316",
    descricao: "LIBANO",
    siscomex: "431",
  },
  {
    codigo: "4340",
    descricao: "LIBERIA",
    siscomex: "434",
  },
  {
    codigo: "4383",
    descricao: "LIBIA",
    siscomex: "438",
  },
  {
    codigo: "4405",
    descricao: "LIECHTENSTEIN",
    siscomex: "440",
  },
  {
    codigo: "4421",
    descricao: "LITUANIA, REPUBLICA DA",
    siscomex: "449",
  },
  {
    codigo: "4553",
    descricao: "MALASIA",
    siscomex: "455",
  },
  {
    codigo: "3595",
    descricao: "MAN, ILHA DE",
    siscomex: "359",
  },
  {
    codigo: "4723",
    descricao: "MARIANAS DO NORTE",
    siscomex: "472",
  },
  {
    codigo: "930",
    descricao: "MIANMAR (BIRMANIA)",
    siscomex: "93",
  },
  {
    codigo: "5010",
    descricao: "MONTSERRAT,ILHAS",
    siscomex: "501",
  },
  {
    codigo: "5312",
    descricao: "NIUE,ILHA",
    siscomex: "531",
  },
  {
    codigo: "5665",
    descricao: "PACIFICO,ILHAS DO (POSSESSAO DOS EUA)",
    siscomex: "566",
  },
  {
    codigo: "6076",
    descricao: "PORTUGAL",
    siscomex: "607",
  },
  {
    codigo: "8885",
    descricao: "CONGO, REPUBLICA DEMOCRATICA DO",
    siscomex: "888",
  },
  {
    codigo: "7102",
    descricao: "SANTA HELENA",
    siscomex: "710",
  },
  {
    codigo: "7056",
    descricao: "SAO VICENTE E GRANADINAS",
    siscomex: "705",
  },
  {
    codigo: "7641",
    descricao: "SUECIA",
    siscomex: "764",
  },
  {
    codigo: "7722",
    descricao: "TADJIQUISTAO, REPUBLICA DO",
    siscomex: "772",
  },
  {
    codigo: "1619",
    descricao: "FORMOSA (TAIWAN)",
    siscomex: "161",
  },
  {
    codigo: "8230",
    descricao: "TURCAS E CAICOS,ILHAS",
    siscomex: "823",
  },
  {
    codigo: "8478",
    descricao: "UZBEQUISTAO, REPUBLICA DO",
    siscomex: "847",
  },
  {
    codigo: "8907",
    descricao: "ZAMBIA",
    siscomex: "890",
  },
  {
    codigo: "6653",
    descricao: "ZIMBABUE",
    siscomex: "665",
  },
];
